import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {BrandEnum} from './brand'

export const OverviewTemplateSettingsSchema = buildEntrySchemaFor('overviewTemplateSettings', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      brand: safeOptional(BrandEnum),
    }),
  ),
})
export type OverviewTemplateSettings = z.infer<typeof OverviewTemplateSettingsSchema>
